import SearchView from "../../components/search/SearchView";
import { TypeDocument } from "../../enums/TypeDocument.enum";

function getTypeDocumentFromRoute() {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  if (subdomain === 'gestiondocumentalamnistia') {
    return { typeDocument: TypeDocument.AMNISTIA, amnistia: true };
  }

  if (subdomain === 'gestiondocumentalsentencias') {
    return { typeDocument: TypeDocument.SENTENCIAS, amnistia: false };
  }

  if (subdomain === 'gestiondocumentalacuerdos') {
    return { typeDocument: TypeDocument.ACUERDOS, amnistia: false };
  }

  if (subdomain === 'gestiondocumentaljurisprudencias') {
    return { typeDocument: TypeDocument.JURISPRUDENCIAS, amnistia: false };
  }

  return { typeDocument: undefined, amnistia: false };
}

export default function SearchLogged() {
  const { typeDocument, amnistia } = getTypeDocumentFromRoute();

  return <SearchView typeDocument={typeDocument} amnistia={amnistia}/>;
}
